import React from "react";
import StockSupplierPriceService from "services/stock-supplier-price";

import { connect } from "react-redux";
import { loadSupplierPrice } from "reducers/stock";

class StockSupplierPrice extends React.Component {
  stockSupplierPriceService = new StockSupplierPriceService();

  constructor() {
    super(...arguments);
    this.load();
  }

  async load() {
    await this.stockSupplierPriceService
      .getAll()
      .then(({ data }) => this.props.loadSupplierPrice(data));
  }

  render() {
    return null;
  }
}

export default connect(null, { loadSupplierPrice })(StockSupplierPrice);
